<template>
<div v-if="!modal_open">
  <div class="desktopContact">
    <div class="contact-wrapper">
      <div id="formWrapper" class="form-wrapper form-container" v-if="form">
        <div class="form-header">
          <div class="columns is-vcentered is-mobile">
            <div class="column" />
            <div class="column">
              <div class="button form-button">
                <div class="header-title">Get in touch</div>
                <span class="icon is-small">
                  <img :src="require('@/assets/images/PNG/MyGymChecker-Logomark-PNG-WhiteBlue.png')" />
                </span>
              </div>
            </div>
            <div class="column has-text-right">
              <a @click="openForm('non-loading')" class="form-button close-button bold is-rounded">-</a>
            </div>
          </div>
        </div>
        <div class="form-content">
          <div class="has-text-centered">
            <p class="sign-up-question bold">Are you hoping to see your Gym here?</p>
            <router-link to="/register" ><span @click="openForm('non-loading')">Click here.</span></router-link>
            <p class="sign-up-direction">If you have another question, please fill in the form below</p>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  </div>
  <div class="mobileContact">
    <div :class="['modal', {'is-active': mobileModal}]">
      <div class='modal-background'></div>
      <div class="modal-content">
        <div class="contact-wrapper">
          <div id="formWrapper" class="form-wrapper form-container" v-if="form">
            <div class="form-header">
              <div class="columns is-vcentered is-mobile">
                <div class="column" />
                <div class="column">
                  <div class="button form-button">
                    <div class="header-title">Get in touch</div>
                    <span class="icon is-small">
                      <img :src="require('@/assets/images/PNG/MyGymChecker-Logomark-PNG-WhiteBlue.png')" />
                    </span>
                  </div>
                </div>
                <div class="column has-text-right">
                  <a @click="openForm('non-loading')" class="form-button close-button bold is-rounded">-</a>
                </div>
              </div>
            </div>
            <div class="form-content">
              <div class="has-text-centered">
                <p class="sign-up-question bold">Are you hoping to see your Gym here?</p>
                <router-link to="/register" ><span @click="openForm('non-loading')">Click here.</span></router-link>
                <p class="sign-up-direction">If you have another question, please fill in the form below</p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="contactWidget">
    <ContactWidget
      :class="[ 'widget', { 'hidden' : loading_timeout }]"
      :loading="button_loading"
      @click="openForm('loading')"
    />
  </div>
</div>
</template>

<script>
import ContactWidget from "@/components/atoms/ContactWidget.vue";
import ContactForm from "@/components/molecules/ContactForm.vue";
export default {
  components: {
    ContactWidget,
    ContactForm
  },
  computed: {
    modal_open() {
      return this.$store.state.free_pass_form_open;
    }
  },
  data() {
    return {
      form: false,
      button_loading: false,
      loading_timeout: false,
      mobileModal: false,
    };
  },
  methods: {
    openForm(state) {
      if (state == "loading") {
        setTimeout(() => {
          this.button_loading = !this.button_loading;
          this.loading_timeout = !this.loading_timeout;
          this.form = !this.form;
          this.mobileModal = !this.mobileModal;
        }, 500);
      }
      if (state == "non-loading") {
        this.button_loading = false;
        this.form = !this.form;
        this.loading_timeout = false;
        this.mobileModal = !this.mobileModal;
      }
    }
  }
};
</script>

<style scoped>
.form-wrapper {
  background: white;
  border-radius: 16px;
}

.form-header {
  background: #333333;
  padding: 1rem;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
}

.form-container {
  border: 1px solid #00c5fd;
  margin-left: 0.5rem;
  margin-right: 0.5rem
}

.contact-wrapper {
  border-radius: 1rem;
  overflow-y: visible;
}

.contactWidget {
  min-width: 6rem;
  text-align: center;
}

.form-content {
  padding: 0.5rem;
}

.header-title {
  background: transparent;
}

.modal.is-active {
  overflow: scroll;
}

.hidden {
  display: none;
}

.modal-content {
  max-height: calc(100vh - 1rem);
  overflow-y: visible;
}

.sign-up-question {
  color: black;
}

.close-button {
  font-size: 2rem;
  padding: 0.5rem;
}

.sign-up-direction {
  font-weight: 250 !important;
  font-size: 1rem;
}

.form-button {
  border: none !important;
  background: #333333 !important;
  color: white !important;
  font-weight: 500;
}

.mobileContact {
  display: none;
  width: 100vw;
  height: 100vh;
}

@media only screen and (max-width: 768px){
  .mobileContact{
    display: initial
  }
  .desktopContact {
    display: none;
  }
}
</style>